
export const getUserHeaders = (user, accessToken) => {

	const userHeaders = {
		'Lang': user?.languageCode ? user.languageCode : 'en',
		'CiamEnabled': true
	};

	if (accessToken) {
		userHeaders['Authorization'] = `Bearer ${accessToken}`;
	}

	return userHeaders;
};

/**
 * Creates generic header attributes and additional endpoint specific ones
 */
export const getEndpointHeaders = (endpoint) => {

	const newHeader = {
		'Cache-Control': 'no-cache',
		'X-Requested-With': 'XMLHttpRequest',
		...endpoint.version && { 'API-Version': endpoint.version },
		...endpoint.featureCode && { 'FeatureCode': endpoint.featureCode },
	};

	return newHeader;
};
